import * as React from "react";

const SvgIcnMessaging = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M18 5a2 2 0 012 2v9a2 2 0 01-2 2H8l-2.388 1.847A1 1 0 014 19.056V7a2 2 0 012-2h12zm0 1H6a1 1 0 00-1 1v12.056L7.658 17H18a1 1 0 001-1V7a1 1 0 00-1-1zm-4.5 7a.5.5 0 010 1h-6a.5.5 0 010-1h6zm3-2a.5.5 0 010 1h-9a.5.5 0 010-1h9zm0-2a.5.5 0 010 1h-9a.5.5 0 010-1h9z"
        />
    </svg>
);

export default SvgIcnMessaging;
